// 导入必要的样式、组件和hooks
import './Dashboard.less';
import { useState, useRef, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { authService, userService } from '@/api/index';
import Icon from '@/components/iconfont/Icon.jsx';
import member from '@/assets//member-tag.png';
// import credit from '@/assets/layouts/dashboard/Credits.png';
// import discord from '@/assets/layouts/dashboard/discord.png';
// import transform from '@/assets/layouts/dashboard/transform.png';
// import select from '@/assets/layouts/dashboard/select.png';
// import logo from '@/assets/logot-v3.png';
// import avatar from '@/assets/avatar.png';
import TextureNoise from '@/assets/logo.png';
import ava from '@/assets/headimg.png';
import { useTranslation } from 'react-i18next';
import i18n, { LANGUAGE_OPTIONS } from '@/utils/i18n.ts';
// import { checkUrlLanguage } from '@/utils/i18n.ts';
// import { UseUserLevel } from '@/hooks/levelHooks.js';
// import ImgSetting from '@/assets/layouts/dashboard/home_nav_settings.svg';
export const DISCORD_URL = 'https://discord.gg/TWmQRqKN';
import Navigation from './components/Navigation/Navigation.jsx';
import { removeToken } from '@/utils/cookie.js';
import { setUserInfo } from '@/store/slices/userInfo.js';
import { setShowPricePage } from '@/store/slices/home.js';

import { useDispatch, useSelector } from 'react-redux';
import PricingPage from '@/pages/pricingPage/PricingPage.jsx';
import { reportData } from '@/utils/trackingPoint.js';
import SentryTracker from '@/utils/Sentry/sentryUtils.js';

function Dashboard() {
  // const [userData, setUserData] = useState({});
  // const userData = { avatar: avatar };
  const [dropOpen, setDropOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [score, setScore] = useState(0);

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);

  const home = useSelector((state) => state.home);

  // const [avatarLoading, setAvatarLoading] = useState(true);
  // const [avatarTimestamp, setAvatarTimestamp] = useState(new Date().getTime());
  const { t } = useTranslation();

  // 获取导航函数
  const navigate = useNavigate();

  const location = useLocation();

  const [showNavigate, setShowNavigate] = useState(true);

  useEffect(() => {
    if (
      ['/texture', '/preview', '/textureUnity'].includes(location.pathname) ||
      location.pathname.includes('/texture/') ||
      location.pathname.includes('/preview/')
    ) {
      setShowNavigate(false);
    } else {
      setShowNavigate(true);
    }
    // 你可以在这里执行任何副作用，如统计、请求等
  }, [location]);

  useEffect(() => {
    if (!['/login'].includes(location.pathname)) {
      queryUserInfo();
    }
  }, []);

  const menuRef = useRef(null);

  // const handleToDiscord = () => {
  //   window.open(DISCORD_URL, '_black');
  // };

  const queryUserInfo = async () => {
    try {
      const res = await userService.userDetail();
      if (res.code === 0) {
        dispatch(setUserInfo(res.data));
        SentryTracker.setUser({
          email: res.data.email,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleSignout = async () => {
    reportData('profile-signout');
    await authService.logout();
    removeToken();
    navigate('/login');
    window.location.reload();
  };

  const mouseHoverShow = (event) => {
    event.stopPropagation();
    reportData('navbar-profile');
    setDropOpen(!dropOpen);
    setLanguageOpen(false);
  };

  const changeLanguage = async (language) => {
    await i18n.changeLanguage(language);
    setLanguageOpen(false);
    setDropOpen(false);
  };

  // const handleToSetting = () => {
  //   navigate('/settings');
  //   mouseLeaveClose();
  // };
  // const handleToLanguage = () => {
  //   const languageCode = localStorage.getItem('i18nextLng') || 'en-US';
  //   setLanguagType(languageList.findIndex((item) => item.code.includes(languageCode)));
  //   setlanguagOpen((res) => !res);
  // };
  // const changeLanguage = (index) => {
  //   const languageCode = languageList[index].code[0];
  //   checkUrlLanguage(languageCode);
  //   mouseLeaveClose();
  // };
  // const buyCredits = (type) => {
  //   localStorage.setItem('pricing_type', type);
  // };

  // useEffect(() => {
  //   if (userData?.avatar) {
  //     setAvatarTimestamp(new Date().getTime());
  //   }
  // }, [userData]);

  const getLevelStr = () => {
    // 1免费, 2:starter 月 , 4:starter 年 ,8:creater 月,16:creater 年
    if (userInfo.subscriptionId === 1) {
      return t('app.standard');
    } else if (userInfo.subscriptionId === 2 || userInfo.subscriptionId === 4) {
      return t('app.starter');
    } else if (userInfo.subscriptionId === 8 || userInfo.subscriptionId === 16) {
      return t('app.creator');
    }
  };
  return (
    <div
      className="dashboard-layout"
      onClick={() => {
        setDropOpen(false);
      }}>
      {/* 头部 */}
      <div className="header">
        <img
          src={TextureNoise}
          onClick={() => {
            window.location.href =
              window.location.protocol +
              '//' +
              window.location.host +
              '/home?random=' +
              new Date().getTime();
            // navigate('/');
            // setTimeout(() => {
            //   window.location.reload(true);
            // });
          }}
          className="imgs"
          alt=""
        />

        <div
          className="member_icon"
          onClick={() => {
            reportData('navbar-upgrade');
            dispatch(setShowPricePage(true));
          }}>
          {t('As_Home_TopNavUpgrade')}
          <img className="member_img" src={member} alt="" />
        </div>
        {/* 用户头像下拉菜单 */}
        <div className="dropdown dropdown-bottom dropdown-end dropdown-open" style={{ zIndex: 99 }}>
          {/*{avatarLoading ? (*/}
          {/*  <div className="skeleton shrink-0 rounded-full"></div>*/}
          {/*) : (*/}
          <img
            tabIndex={0}
            className="avatar_img"
            src={ava}
            alt=""
            onClick={(event) => mouseHoverShow(event)}
          />
          {/*)}*/}

          {dropOpen && (
            <ul
              onClick={(event) => {
                event.stopPropagation();
              }}
              tabIndex={0}
              className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow"
              ref={menuRef}>
              <div className="rashaun_box">
                <div className="title">{userInfo.username}</div>
                <div className="email">{userInfo.email}</div>
              </div>

              <div className="menus">
                <div className="vip">
                  <div className="icon"></div>
                  <div className="title">{getLevelStr()}</div>
                  <div
                    className="upgrade-button"
                    onClick={() => {
                      dispatch(setShowPricePage(true));
                      setDropOpen(false);
                      reportData('profile-upgrade');
                    }}>
                    {t('app.upgrade')}
                  </div>
                </div>
                <div
                  className="settings"
                  onClick={() => {
                    navigate('/setting');
                    setDropOpen(false);
                    reportData('profile-settings');
                  }}>
                  <div className="icon"></div>
                  <div className="title">{t('app.settings')}</div>
                </div>
                <div className="language-setting">
                  <div
                    className="language-setting-trigger"
                    role="button"
                    tabIndex={0}
                    aria-expanded={languageOpen}
                    aria-haspopup="listbox"
                    aria-label={t('app.language')}
                    onClick={() => setLanguageOpen((open) => !open)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setLanguageOpen((open) => !open);
                      }
                    }}>
                    <div className="icon">文</div>
                    <div className="title">{t('app.language')}</div>
                    <div className="current-language">
                      {LANGUAGE_OPTIONS.find((item) => item.code === i18n.resolvedLanguage)
                        ?.label || LANGUAGE_OPTIONS[0].label}
                    </div>
                    <div className={'arrow' + (languageOpen ? ' open' : '')} aria-hidden="true" />
                  </div>
                  {languageOpen && (
                    <div className="language-options" role="listbox" aria-label={t('app.language')}>
                      {LANGUAGE_OPTIONS.map((item) => (
                        <button
                          type="button"
                          role="option"
                          aria-selected={i18n.resolvedLanguage === item.code}
                          className={
                            'language-option ' +
                            (i18n.resolvedLanguage === item.code ? 'selected' : '')
                          }
                          key={item.code}
                          onClick={() => changeLanguage(item.code)}>
                          <span>{item.label}</span>
                          {i18n.resolvedLanguage === item.code && <span>✓</span>}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="sign-out" onClick={handleSignout}>
                  <div className="icon"></div>
                  <div className="title">{t('app.signOut')}</div>
                </div>
              </div>
              {/* <div className="score">
                <div className="title">Actual total mesh:</div>
                <div className="value">{userInfo.actualTotalMesh}</div>
              </div>
              <div className="score">
                <div className="title">Actual total points:</div>
                <div className="value">{userInfo.actualTotalPoints}</div>
              </div> */}

              {/*<div className="rashaun_box user_credits">*/}
              {/*  <img className="credits_img" src={member2} alt="" />*/}
              {/*  <div className="credits">*/}
              {/*    <div>{t(UseUserLevel(userData?.subscription?.id))}</div>*/}
              {/*    <div className="menu_more" onClick={() => buyCredits(0)}>*/}
              {/*      {t('As_Home_CreditLimit')}*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</div>*/}
              {/*<div className="rashaun_box user_credits">*/}
              {/*  <img className="credits_img" src={credit} alt="" />*/}
              {/*  <div className="credits">*/}
              {/*    <div>*/}
              {/*      {t('As_Home_Userprofile3')}*/}
              {/*      <span className="credits_num">{userData?.actualTotalPoints}</span>*/}
              {/*    </div>*/}
              {/*    <div className="menu_more" onClick={() => buyCredits(2)}>*/}
              {/*      {t('As_Home_Userprofile4')}*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</div>*/}
              {/*<li className="li_item first_li" onClick={handleToSetting}>*/}
              {/*  <a className="meanblock">*/}
              {/*    <img src={ImgSetting} />*/}
              {/*    {t('As_Home_Settingsoption')}*/}
              {/*  </a>*/}
              {/*</li>*/}
              {/*<li className="li_item" onClick={handleToDiscord}>*/}
              {/*  <a>*/}
              {/*    <img src={discord} />*/}
              {/*    {t('As_Home_Socialmedialink')}*/}
              {/*  </a>*/}
              {/*</li>*/}
              {/*<li*/}
              {/*  className="li_item dropdown dropdown-left dropdown-end dropdown-open"*/}
              {/*  onMouseEnter={handleToLanguage}*/}
              {/*  onMouseLeave={() => {*/}
              {/*    setlanguagOpen(false);*/}
              {/*  }}>*/}
              {/*  <a tabIndex={0} role="button">*/}
              {/*    <img src={transform} />*/}
              {/*    {t('As_Home_Languageoption')}*/}
              {/*  </a>*/}
              {/*  {languagOpen && (*/}
              {/*    <ul*/}
              {/*      tabIndex={0}*/}
              {/*      className="dropdown-content menu bg-base-100 z-[99] w-52 p-2 language_list shadow-sm rounded-box">*/}
              {/*      {languageList.map((res, index) => (*/}
              {/*        <li*/}
              {/*          className="language_item"*/}
              {/*          key={index}*/}
              {/*          onClick={() => changeLanguage(index)}>*/}
              {/*          <a className="language_state">*/}
              {/*            <span className="language_label">{res.lable}</span>*/}
              {/*            {languagType == index && <img src={select} />}*/}
              {/*          </a>*/}
              {/*        </li>*/}
              {/*      ))}*/}
              {/*    </ul>*/}
              {/*  )}*/}
              {/*</li>*/}
              {/* <li onClick={handleSignout} className="li_item first_li">
                <a>
                  <Icon name="icon-out" className="navicon quit" />
                  {t('As_Nav_Avatar2')}
                </a>
              </li> */}
            </ul>
          )}
        </div>
      </div>
      <div className="dashboard_box">
        {showNavigate ? <Navigation></Navigation> : <></>}
        <div className="dashboard-content scrollbar-thin scrollbar-track-transparent">
          <Outlet></Outlet>
        </div>
      </div>
      {home.showPricePage && (
        <PricingPage
          close={() => {
            dispatch(setShowPricePage(false));
          }}></PricingPage>
      )}
    </div>
  );
}

export default Dashboard;
